import { useCallback, useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { hardReload } from "@/lib/lazyRetry";
import { hasUnsavedWork } from "@/lib/unsaved";
import { checkVersion } from "@/lib/version";

const EVERY = 5 * 60 * 1000;

// Polls /version.json (no-store) every 5 min and on focus; a different build shows a small non-blocking banner.
export const VersionBanner = () => {
  const [stale, setStale] = useState(false);
  const [hidden, setHidden] = useState(false);
  const check = useCallback(async () => { if (await checkVersion()) setStale(true); }, []);
  useEffect(() => {
    check();
    const id = setInterval(check, EVERY);
    window.addEventListener("focus", check);
    return () => { clearInterval(id); window.removeEventListener("focus", check); };
  }, [check]);
  if (!stale || hidden) return null;
  const reload = () => {
    if (hasUnsavedWork() && !window.confirm("You have unsaved text in an editor. Reload anyway? Reply drafts are autosaved; other unsaved changes will be lost.")) return;
    hardReload();
  };
  return (
    <div className="fixed bottom-4 left-1/2 z-[100] flex -translate-x-1/2 items-center gap-3 rounded-md border bg-card px-4 py-2 text-sm shadow-lg" role="status" data-testid="version-banner">
      <span>A new version is available</span>
      <Button size="sm" onClick={reload} data-testid="version-banner-reload"><RefreshCw className="mr-1 h-3.5 w-3.5" />Reload</Button>
      <button type="button" onClick={() => setHidden(true)} aria-label="Dismiss" data-testid="version-banner-dismiss"><X className="h-4 w-4 text-muted-foreground" /></button>
    </div>
  );
};
